import React from 'react';
import PropTypes from 'prop-types';
import styles from './index.css';
import errorBoundary from '@ifeng-fe/errorBoundary';
import Chip from 'Chip';
import ChipEdit from 'ChipEdit';
import chipDataTransform from 'chipDataTransform';
import Header from './header';
import Logo from './logo';
import Content from './content';
import BottomFooter from './bottomFooter';

const Layout = ({ content }) => {
    const { nav, logo, footer, recommend, newsstream, isEnd, columnId, recommendId, seo } = content;

    return (
        <div className={styles.layout}>
            <Header content={nav} />
            <Logo content={logo} />
            <div className={styles.divider} />
            <div className={styles.main}>
                <Content
                    content={{
                        recommend,
                        newsstream,
                        isEnd,
                        columnId,
                        recommendId,
                    }}
                />
            </div>
            <BottomFooter content={footer} />
            {/* SEO 可视化入口：左上角空壳 Chip，仅编辑态可见橙色标签 */}
            <Chip id="261187" type="struct" title="SEO配置" groupName="页面配置" content={seo}>
                <div className={styles.content_list}>
                    <div className={styles.chip_item} />
                </div>
            </Chip>
            <ChipEdit transform={chipDataTransform} />
        </div>
    );
};

Layout.propTypes = {
    content: PropTypes.object,
};

export default errorBoundary(Layout);
